<template>
  <v-app
    id="inspire"
    v-if="config.siteConfig.hasOwnProperty('page_title')"
    :style="loggedIn ? 'background-color: #ffffff!important;' : ''"
  >
    <IntercomWidget />
    <ReportViewer />
    <DynamicDialog
      :show="sessionExpiryDialog"
      @dialogOk="continueSession"
      @dialogCancel="logout"
      max-width="520"
      okBtnColor="primary"
      cancelBtnColor="error"
      cancelBtnVariant="text"
      cancelPrependIcon="mdi-logout"
      :hideCloseButton="true"
    >
      <template v-slot:title>Are you still there?</template>
      <template v-slot:content>
        <p>
          You've been inactive for a while. For your security, we'll log you out
          out in
          <span
            class="font-weight-bold"
            style="display: inline-block; width: 200px; text-align: center"
          >
            {{ formattedTime }}
          </span>
          unless you let us know you're still here.
        </p>
      </template>
      <template v-slot:okBtnTitle>Continue working</template>
      <template v-slot:cancelBtnTitle>Log out now</template>
    </DynamicDialog>
    <DynamicDialog
      v-if="
        config.customClientConfig.client_type == 'imd-on-demand' &&
        ($route.name === 'Map' || $route.name === 'Home')
      "
      :show="exitIntentDialog"
      @dialogOk="handleExitIntentOk"
      @dialogCancel="closeExitIntentDialog"
      :max-width="$vuetify.display.xs ? '100vw' : '800'"
      :fullscreen="$vuetify.display.xs"
      okBtnColor="mint"
      cancelBtnColor="error"
      cancelBtnVariant="text"
      :hideCloseButton="false"
      data-testid="IMDexitIntentDialog"
    >
      <template v-slot:title>Save days of research and analysis</template>

      <template v-slot:content>
        <p class="mb-4">
          Save days of manual work and free up your time to focus on the
          analysis that really matters with an instant Indices on Demand report.
        </p>
        <InstantIMDReportCard @button-click="handleExitIntentOk" />
      </template>
      <template v-slot:okBtnTitle>Find out more</template>
      <template v-slot:cancelBtnTitle>Maybe later</template>
    </DynamicDialog>
    <v-navigation-drawer
      v-if="loggedIn"
      v-model="drawer"
      app
      :style="!loggedIn ? 'display:none' : null"
      width="400"
      :inert="!drawer"
    >
      <v-list-item class="px-2 py-4">
        <!-- Local insight branding and client country chip -->
        <v-row class="p-0">
          <v-col align="left">
            <v-img
              transition="false"
              :eager="true"
              width="75%"
              cover
              class="ml-2"
              :src="require('@/assets/localInsight.png')"
              title="Local Insight"
              alt="Local Insight Logo"
            ></v-img>
          </v-col>
          <v-col align="right">
            <v-chip
              v-if="config.siteConfig.site_country"
              class="ml-2"
              color="#F9F9F9"
              variant="flat"
              slim
              >{{ countryLabel }}</v-chip
            >
          </v-col>
        </v-row>
      </v-list-item>
      <v-list-item
        v-if="loggedIn && !config.userProfile.is_public_site_user_profile"
        class="text-left px-4 pb-4"
      >
        <!--   Public site  -->
        <div v-if="config.siteConfig.is_public_site">
          <v-list-item-subtitle>
            {{ this.config.siteConfig.tag_line }}
          </v-list-item-subtitle>
        </div>
        <!--  normal site  -->
        <span v-else>
          <v-list-item-title class="text-h6" style="font-weight: 600">
            {{ this.config.userProfile.name }}
          </v-list-item-title>
          <v-list-item-subtitle class="pt-1 font-weight-medium">
            {{ this.config.userProfile.role }}
          </v-list-item-subtitle>
        </span>
        <!-- demo expiry card -->
        <v-card
          theme="localInsightLightTheme"
          variant="flat"
          class="bg-inverted-warning on-inverted-warning mt-4"
          v-if="
            this.config.customClientConfig.client_type == 'demo' &&
            this.config.customClientConfig.demo_end_date
          "
        >
          <v-card-text>
            <div class="font-weight-medium" v-if="demoDaysRemaining > 1">
              Your trial period will end in {{ demoDaysRemaining }} days
            </div>
            <div class="font-weight-medium" v-else>
              Your trial period ends today
            </div>
            <div>Some functionality is restricted during the trial</div>
          </v-card-text>
        </v-card>
        <!-- Show client selector if there is more than one choice -->
        <v-list-item-subtitle
          v-if="
            config.otherSites.length > 0 ||
            config.userConfig.otherClients.length > 0
          "
          class="pt-4"
        >
          <v-select
            v-if="config.otherSites.length"
            :model-value="switchSite ? switchClient : config.siteConfig.name"
            :items="config.otherSites"
            label="Your Sites"
            id="switchSite"
            item-title="name"
            return-object
            focused
            tabindex="1"
            variant="outlined"
            density="comfortable"
            rounded="0"
            @update:model-value="
              (newValue) => {
                switchSite = newValue;
                visitSite(switchSite.url);
              }
            "
          ></v-select>
          <v-autocomplete
            v-if="config.userConfig.otherClients.length"
            :model-value="
              switchClient
                ? switchClient
                : this.config.customClientConfig.client_name
            "
            :items="config.userConfig.otherClients"
            label="Change Client"
            id="switchClient"
            data-testid="switchClient"
            no-data-text="No clients found"
            item-title="client_name"
            :clearable="true"
            return-object
            focused
            tabindex="1"
            variant="outlined"
            density="comfortable"
            rounded="0"
            @update:model-value="
              (newValue) => {
                switchClient = newValue;
                switchToDifferentClient();
              }
            "
            autocomplete="off"
          ></v-autocomplete>
        </v-list-item-subtitle>
      </v-list-item>

      <v-divider></v-divider>
      <!-- not logged in / public site anonymous user nav-->
      <v-list
        v-if="config.userProfile.is_public_site_user_profile"
        nav
        lines="one"
        id="navList"
        class="text-left moduleList"
      >
        <template v-for="item in config.userConfig.modules" :key="item.slug">
          <v-list-item
            v-if="showModuleInNav(item)"
            link
            :key="item.slug"
            :id="item.label"
            @click="router(item.route)"
            tabindex="1"
            :title="item.label"
            class="mb-0"
          >
            <template v-slot:prepend>
              <v-icon :icon="'mdi-' + item.icon"></v-icon>
            </template>
            <template v-slot:append>
              <OcsiOnlyChip v-if="item.ocsiOnly"></OcsiOnlyChip>
              <NewChip v-if="showNewChip(item.slug)"></NewChip>
            </template>
          </v-list-item>
        </template>
      </v-list>
      <!-- logged in / logged in public site user nav-->
      <v-list v-else nav lines="one" id="navList" class="text-left moduleList">
        <span
          v-for="(navGroup, index) in config.userConfig.modules"
          :key="navGroup.groupTitle"
        >
          <v-list-subheader class="text-uppercase text-caption mt-2">{{
            navGroup.groupTitle
          }}</v-list-subheader>
          <v-list-item
            v-for="item in navGroup.groupModules"
            link
            :key="item.slug"
            :id="item.label"
            @click="router(item.route)"
            tabindex="1"
            :title="item.label"
            class="mb-0"
          >
            <template v-slot:prepend>
              <v-icon :icon="'mdi-' + item.icon"></v-icon>
            </template>
            <template v-slot:append>
              <OcsiOnlyChip v-if="item.ocsiOnly"></OcsiOnlyChip>
              <NewChip v-if="showNewChip(item.slug)"></NewChip>
            </template>
          </v-list-item>
          <v-divider
            v-if="index !== config.userConfig.modules.length - 1"
            class="mt-2"
          ></v-divider>
        </span>
      </v-list>

      <v-divider></v-divider>
      <template v-slot:append>
        <div>
          <v-list nav lines="one" class="text-left extraModuleList">
            <v-list-item
              class="mb-0"
              link
              href="https://localinsight.org/blog/"
              target="_blank"
              tabindex="1"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-newspaper-variant-outline"></v-icon>
              </template>
              <v-list-item-title>News</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="isGroupAdmin"
              class="mb-0"
              link
              href="https://localinsight.org/enhance-local-insight-with-an-add-on-to-your-subscription/?utm_source=platform&utm_medium=side-navigation-menu&utm_campaign=explore-add-ons"
              target="_blank"
              tabindex="1"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-plus-box"></v-icon>
              </template>
              <v-list-item-title>Explore Add-ons</v-list-item-title>
            </v-list-item>
            <v-list-item
              id="help-centre-item"
              class="mb-0"
              link
              href="https://support.localinsight.org"
              target="_blank"
              tabindex="1"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-lifebuoy"></v-icon>
              </template>
              <v-list-item-title>Help Centre</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="!config.userProfile.is_public_site_user_profile"
              link
              href="https://support.localinsight.org/en/collections/623779-getting-help"
              target="_blank"
              tabindex="1"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-human-greeting-proximity"></v-icon>
              </template>
              <v-list-item-title>Contact</v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              href="https://localinsight.org/accessibility-statement/"
              target="_blank"
              aria-label="accessibility statement"
              tabindex="1"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-human"></v-icon>
              </template>
              <v-list-item-title>Accessibility Statement</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="!config.userProfile.is_public_site_user_profile"
              @click="logout"
              class="text-red"
              tabindex="1"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-logout-variant"></v-icon>
              </template>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="config.userProfile.is_public_site_user_profile"
              @click="router('login')"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-logout-variant"></v-icon>
              </template>
              <v-list-item-title>Sign In</v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      density="compact"
      app
      :style="
        loggedIn
          ? 'background-color: ' +
            this.config.siteConfig.toolbar_colour +
            '; align-items: center;'
          : 'display:none'
      "
      id="appBar"
      class="topBar"
    >
      <!-- Custom On Demand header -->
      <div
        v-if="
          $route.path.includes('purchase/imd-report') ||
          $route.path.includes('/order/')
        "
        class="w-100"
      >
        <!-- For mobile just a centered logo all the time -->
        <v-row align="center" v-if="isMobile">
          <v-col align="center" cols="12">
            <v-img
              max-height="40"
              max-width="178"
              contain
              :src="config.siteConfig.logo"
              alt="Company Logo"
            ></v-img>
          </v-col>
        </v-row>

        <!-- For desktop slightly different layout -->
        <v-row v-else align="center">
          <v-col cols="4" align="left" class="pa-0 pl-9">
            <v-img
              v-if="$route.path.includes('/order/')"
              max-height="40"
              max-width="178"
              contain
              :src="config.siteConfig.logo"
              alt="Company Logo"
            ></v-img>
          </v-col>
          <v-col cols="4" align="center" class="pa-0">
            <v-img
              v-if="!$route.path.includes('/order/')"
              max-height="40"
              max-width="178"
              contain
              :src="config.siteConfig.logo"
              alt="Company Logo"
            ></v-img
          ></v-col>
          <v-col cols="4" align="right" class="pa-0 pr-9">
            <v-btn
              v-if="$route.path.includes('/order/')"
              variant="elevated"
              color="primary"
              rounded="0"
              append-icon="mdi-arrow-right"
              @click="$router.push({ path: '/purchase/imd-report' })"
            >
              Place another order
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Default header -->
      <div style="display: contents" v-else>
        <v-app-bar-nav-icon
          @click="drawer = !drawer"
          :color="titleTextColor"
          id="navMenu"
          tabindex="1"
          title="Navigation"
        ></v-app-bar-nav-icon>
        <v-img
          class="ml-2"
          max-height="40"
          max-width="178"
          contain
          :src="config.siteConfig.logo"
          @click="router('map')"
          style="cursor: pointer"
          title="Map"
          alt="Company Logo"
        ></v-img>
        <EnvironmentTag />
        <v-row
          v-if="!isMobile"
          align="center"
          class="h1 pl-4 ml-1 text-left dynamicTextColour clientName"
          title="Client Name"
        >
          <span
            v-if="this.config.customClientConfig.client_name"
            aria-label="Client Name"
            class="clientNameText"
            >{{ this.config.customClientConfig.client_name }}</span
          >
          <span v-else aria-label="Client Name" class="clientNameText">{{
            this.config.siteConfig.name
          }}</span>
        </v-row>
        <v-spacer />
        <v-row align="center" justify="end" class="mr-1 headerRight">
          <!-- Reports progress -->
          <v-col
            v-if="reportDownloaded || reportDownloading"
            class="reportsCol"
          >
            <v-row align-content="end" no-gutters>
              <v-col cols="9" class="pr-4 pt-1 text-white">
                <v-progress-linear
                  v-if="!reportDownloaded"
                  v-model="progressLinear"
                  color="success"
                  height="25"
                  striped
                >
                  <div
                    v-if="reportLoadingProgress < 100"
                    class="font-weight-medium"
                  >
                    <strong
                      >Loading Themes {{ Math.ceil(progressLinear) }}%</strong
                    >
                  </div>
                  <div v-else class="font-weight-medium">
                    <strong
                      >Aggregating {{ Math.ceil(progressLinear) }}%</strong
                    >
                  </div>
                </v-progress-linear>
              </v-col>
              <v-col cols="3">
                <v-btn
                  color="success"
                  tile
                  variant="elevated"
                  @click="openReport"
                  title="view report"
                  aria-label="View Report"
                  :disabled="!reportDownloaded"
                >
                  {{ !reportDownloaded ? "Wait" : "Report" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <!-- Custom button for sites like imd. -->
          <v-btn
            v-if="
              config.customClientConfig.client_type == 'imd-on-demand' &&
              ($route.name === 'Map' || $route.name === 'Home')
            "
            color="mint"
            variant="elevated"
            @click="router('purchase/imd-report')"
            title="Get your Indices on Demand report"
            aria-label="Get your Indices on Demand report"
            class="mr-0 imdBtn"
            rounded="0"
          >
            Get your Indices on Demand report
          </v-btn>
          <!--   Extra pages text buttons  -->
          <v-card-actions
            v-if="config.userProfile?.is_public_site_user_profile"
          >
            <div v-for="page in config.userConfig.modules" :key="page.route">
              <v-btn
                v-if="
                  page.hasOwnProperty('show_at_header') && page.show_at_header
                "
                variant="text"
                @click="router(page.route)"
                :style="'color: ' + titleTextColor"
              >
                {{ page.label }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-row>
      </div>
    </v-app-bar>

    <v-main
      id="mainApp"
      :style="!loggedIn ? 'padding:0px!important' : null"
      style="overflow: hidden"
    >
      <v-snackbar
        theme="localInsightLightTheme"
        id="ocsi-snackbar"
        class="mb-6"
        :class="snackbar?.textColour ?? 'text-white'"
        style="z-index: 100000001"
        v-model="snackbarVisible"
        :color="snackbar.colour"
        :location="snackbar.location"
        :rounded="snackbar.rounded"
        :timeout="snackbar.timeout"
        :multi-line="snackbar.rounded !== 'pill'"
      >
        <!-- pill snackbar title. -->
        <div
          v-if="snackbar.title && snackbar.rounded === 'pill'"
          :style="this.snackbar.width ? 'width: ' + this.snackbar.width : ''"
          :id="snackbar.id"
          :class="snackbar?.textColour ?? 'text-white'"
        >
          <v-icon v-if="snackbar.icon" size="15" class="mr-2">{{
            snackbar.icon
          }}</v-icon>
          {{ snackbar.title }}
          <span v-if="snackbar.rounded === 'pill' && snackbar.showClose">
            <v-btn
              tile
              variant="text"
              slim
              size="small"
              :style="{ 'min-width': 0 }"
              width="10"
              @click="snackbarVisible = false"
              aria-label="Close"
              >x</v-btn
            >
          </span>
        </div>
        <!-- regular snackbar title -->
        <div
          v-if="snackbar.title && snackbar.rounded !== 'pill'"
          class="text-h6 pb-3"
          :class="snackbar?.textColour ?? 'text-white'"
          :style="this.snackbar.width ? 'width: ' + this.snackbar.width : ''"
          :id="snackbar.id"
        >
          <v-icon v-if="snackbar.icon" class="pr-3 mr-2">{{
            snackbar.icon
          }}</v-icon>
          {{ snackbar.title }}
        </div>
        <v-row>
          <!-- message -->
          <v-col :cols="snackbar?.contactSupportBtn ? 8 : 12">
            <div
              v-if="snackbar.message"
              class="text-subtitle-1 pb-2 ml-10"
              :class="snackbar?.textColour ?? 'text-white'"
              id="snackBarMessage"
              v-html="snackbar.message"
            ></div>
          </v-col>
          <v-col v-if="snackbar?.contactSupportBtn" cols="4" align-self-center>
            <!-- contact support button -->
            <div>
              <v-btn
                :class="snackbar?.textColour ?? 'text-white'"
                tile
                variant="text"
                :href="'mailto:support@ocsi.co.uk?subject=' + snackbar.title"
                aria-label="Contact Support"
              >
                Contact Support
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!-- close button -->
        <div
          v-if="snackbar.rounded !== 'pill' && snackbar.showClose"
          style="width: 100%; text-align: right"
        >
          <v-btn
            :class="snackbar?.textColour ?? 'text-white'"
            tile
            variant="text"
            @click="snackbarVisible = false"
            aria-label="Close"
            >Close</v-btn
          >
        </div>
        <div
          v-if="snackbar.rounded !== 'pill' && snackbar.button"
          style="width: 100%; text-align: right"
        >
          <v-btn
            :class="snackbar?.textColour ?? 'text-white'"
            tile
            variant="text"
            @click="snackbar.button.callback()"
            aria-label="Close"
          >
            <div v-html="snackbar.button.text"></div>
          </v-btn>
        </div>
      </v-snackbar>
      <div class="progressBar" :style="!showLoader ? 'display:none;' : null">
        <v-progress-linear
          indeterminate
          color="#8DC8F1"
          height="6"
        ></v-progress-linear>
      </div>
      <div
        class="antiMasher"
        :style="!showAntiMasher ? 'display:none' : null"
      ></div>
      <router-view />
    </v-main>

    <MobileDevicesNotSupportedMessage
      v-if="
        isMobile && loggedIn && !config.userProfile.is_public_site_user_profile
      "
      :isMobile="isMobile"
    />
  </v-app>
  <v-app v-else-if="isSuspendedOnProduction">
    <v-alert text prominent color="#2196F3">
      <h2 class="text-black" style="font-family: Inter, sans-serif">
        Sorry but it appears this account is inactive.
      </h2>
      <h3 class="text-black" style="font-family: Inter, sans-serif">
        Please contact support@ocsi.co.uk if you require more information.
      </h3>
    </v-alert>
  </v-app>
  <v-app v-else-if="notSigned" style="background-color: #f9f9f9">
    <TermsAndConditions @logout="logout" />
  </v-app>
  <v-app v-else-if="sessionExpired">
    <DynamicDialog
      :show="true"
      @dialogOk="logInAgain"
      max-width="520"
      okBtnColor="primary"
      :hideCloseButton="true"
      :cancelBtnHidden="true"
    >
      <template v-slot:title>You've been logged out</template>
      <template v-slot:content>
        <p>
          For your security, you've been automatically logged out due to
          inactivity. Please log in again to continue your work.
        </p>
      </template>
      <template v-slot:okBtnTitle>Log in again</template>
    </DynamicDialog>
  </v-app>
  <v-app v-else>
    <div class="loadingLI">
      <v-progress-circular :size="200" :width="3" color="#51627C" indeterminate
        >Loading Local Insight</v-progress-circular
      >
    </div>
  </v-app>
</template>

<script>
import ReportViewer from "@/components/ReportViewer";
import OcsiOnlyChip from "@/components/OcsiOnlyChip";
import NewChip from "@/components/NewChip";
import { getURLParam } from "@/mixins/GetURLParam";
import { getCookie } from "@/mixins/GetCookie";
import { setCookie } from "@/mixins/SetCookie";
import { isBrightColour } from "@/mixins/IsBrightColour";
import { isMobileDevice } from "@/mixins/IsMobileDevice";
import { securedRoutes } from "./router/index.js";
import EnvironmentTag from "./components/EnvironmentTag.vue";
import MobileDevicesNotSupportedMessage from "./components/MobileDevicesNotSupportedMessage.vue";
import IntercomWidget from "@/components/IntercomWidget";
import TermsAndConditions from "@/components/TermsAndConditions";
import DynamicDialog from "@/components/DynamicDialog.vue";
import InstantIMDReportCard from "@/components/InstantIMDReportCard.vue";

export default {
  computed: {
    showLoader: {
      get() {
        return this.showProgressLoader && this.busy;
      },
    },
    headerNavList: {
      get() {
        const filteredObj = {};
        for (const key in this.config.userConfig.modules) {
          if (
            // eslint-disable-next-line no-prototype-builtins
            this.config.userConfig.modules.hasOwnProperty(key) &&
            this.config.userConfig.modules[key]["show_at_header"] === true
          ) {
            filteredObj[key] = this.config.userConfig.modules[key];
          }
        }
        return filteredObj;
      },
    },
    helpCenterLink() {
      let link;
      const isAustralia = this.config.siteConfig.site_country === "aus";
      const isPublicSite = this.config.userProfile.is_public_site_user_profile;

      if (isAustralia) {
        link = isPublicSite
          ? "auslocalinsight.zendesk.com/hc/en-gb/categories/21501045295517-Public-Sites"
          : "auslocalinsight.zendesk.com/hc/en-gb";
      } else {
        link = isPublicSite
          ? "local-insight-public.zendesk.com/hc/en-gb"
          : "local-insight.zendesk.com/hc/en-gb";
      }

      return link;
    },
    progressLinear: {
      get() {
        return this.reportLoadingProgress < 100
          ? this.reportLoadingProgress
          : this.aggregationProgressPercentage;
      },
    },
    reportDownloading: {
      get() {
        return this.$store.state.reportDownloading;
      },
      set(value) {
        this.$store.commit("setReportDownloading", value);
      },
    },
    reportDownloaded: {
      get() {
        return this.$store.state.reportDownloaded;
      },
      set(value) {
        this.$store.commit("setReportDownloaded", value);
      },
    },
    viewReportDialog: {
      get() {
        return this.$store.state.viewReportDialog;
      },
      set(value) {
        this.$store.commit("setViewReportDialog", value);
      },
    },
    aggregationProgressPercentage: {
      get() {
        return this.$store.state.aggregationProgressPercentage;
      },
    },
    reportLoadingProgress: {
      get() {
        return this.$store.state.reportLoadingProgress;
      },
    },
    config: {
      get() {
        return this.$store.state.config;
      },
      set(value) {
        this.$store.commit("setConfig", value);
      },
    },
    busy: {
      get() {
        return this.$store.state.busy;
      },
      set(value) {
        this.$store.commit("setBusy", value);
      },
    },
    showAntiMasher: {
      get() {
        return this.$store.state.showAntiMasher;
      },
      set(value) {
        this.$store.commit("setShowAntiMasher", value);
      },
    },
    favicon: {
      get() {
        return this.config.siteConfig.favicon;
      },
    },
    uatEnvironment() {
      return process.env.VUE_APP_ENVIRONMENT === "uat";
    },
    isOcsiMember: {
      get() {
        return this.$store.state.isOcsiMember;
      },
      set(value) {
        this.$store.commit("setIsOcsiMember", value);
      },
    },
    isGroupAdmin: {
      get() {
        return this.$store.state.isGroupAdmin;
      },
      set(value) {
        this.$store.commit("setIsGroupAdmin", value);
      },
    },
    isPowerUser: {
      get() {
        return this.$store.state.isPowerUser;
      },
      set(value) {
        this.$store.commit("setIsPowerUser", value);
      },
    },
    isViewReports: {
      get() {
        return this.$store.state.isViewReports;
      },
      set(value) {
        this.$store.commit("setIsViewReports", value);
      },
    },
    isPublicUser: {
      get() {
        return this.$store.state.isPublicUser;
      },
      set(value) {
        this.$store.commit("setIsPublicUser", value);
      },
    },
    countryLabel: {
      get() {
        return this.countries[this.config.siteConfig.site_country];
      },
    },
    demoDaysRemaining: {
      get() {
        //demo end date at midnight
        const demoEnd = new Date(
          this.config.customClientConfig.demo_end_date,
        ).setUTCHours(0, 0, 0, 0);
        //current date at midnight
        const today = new Date().setUTCHours(0, 0, 0, 0);
        //compare dates and convert milliseconds to days
        return Math.floor((demoEnd - today) / (1000 * 60 * 60 * 24));
      },
    },
    isOnDemandClient() {
      return this.config.customClientConfig.client_type === "imd-on-demand";
    },
  },
  data: () => ({
    sessionExpired: false,
    sessionExpiryDialog: false,
    notSigned: false,
    isMobile: false,
    showProgressLoader: true,
    viewReportButtonLabel: false,
    snackbarVisible: false,
    countdownTime: 300, // 5 minutes in seconds
    countdownTimer: null,
    formattedTime: "05:00",
    adminEmail: null,
    adminPassword: null,
    adminDialog: false,
    switchClient: null,
    switchSite: null,
    drawer: false,
    loggedIn: false,
    snackbar: {
      message: "this is a message this is a message this is a message",
      title: null,
      timeout: 4000,
      colour: null,
      textColour: "red",
      icon: "mdi-alert-circle-outline",
      location: "top",
      rounded: "none",
      width: null,
    },
    pilotBugTrackerLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdjJ99BpDNswfS7F5_lDZLX9BiyEqQGSckAdzFOvIaZmVEKQg/viewform",
    pilotFeedbackLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfxUVEBolGYSfXsfsuaVttn8qk6W8ypSTz-mkB3A4d34SYQpQ/viewform",
    isSuspendedOnProduction: false,
    titleTextColor: "white",
    referrer: null,
    countries: {
      aus: "Australia",
      eng: "England",
      wls: "Wales",
      sct: "Scotland",
    },
    userModules: [],
    exitIntentDialog: false,
    exitIntentTimer: null,
    exitIntentTriggered: false,
    publicReportCount: 0,
  }),
  components: {
    ReportViewer,
    OcsiOnlyChip,
    NewChip,
    EnvironmentTag,
    MobileDevicesNotSupportedMessage,
    IntercomWidget,
    TermsAndConditions,
    DynamicDialog,
    InstantIMDReportCard,
  },
  watch: {
    favicon() {
      const favicon = document.getElementById("favicon");
      favicon.href = this.config.siteConfig.favicon;
    },
    $route: {
      immediate: true,
      handler(to) {
        const baseTitle = "Local Insight";

        //use router meta.title param for page <title> if exists
        const getRouteTitle = (route) => {
          const t = route?.meta?.title;
          if (typeof t === "function") return t(route);
          return t; // string or undefined
        };
        //fall back from meta.title to router.name or just "Local Insight" if no name exists
        const rawTitle = getRouteTitle(to) ?? to?.name ?? "";
        document.title = rawTitle ? `${rawTitle} | ${baseTitle}` : baseTitle;

        // Clear any existing exit intent timer
        if (this.exitIntentTimer) {
          clearTimeout(this.exitIntentTimer);
          this.exitIntentTimer = null;
        }
        // Set up exit intent if on map page
        if (to.name === "Map") {
          this.setupExitIntent();
        }
      },
    },
  },
  mounted() {
    this.isMobile = isMobileDevice(); // should prolly make this global in the vuex store
    const elHtml = document.getElementsByTagName("html")[0];
    elHtml.style.overflowY = "hidden";
    // listen out for these
    this.emit.on("systemBusy", this.systemBusy);
    this.emit.on("systemMessage", this.displaySnackbar);
    this.emit.on("closeSystemMessage", this.closeSnackbar);
    this.emit.on("getClientAndUserConfig", this.getClientAndUserConfig);
    this.emit.on("session-expiring", this.sessionExpiring);
    // else you will always bee redirected to the same public site
    if (getCookie("OI_PUBLIC_SITE")) {
      document.cookie =
        "BEARER_TOKEN=; domain=.localinsight.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    /**
     * Wait for the router to be initialized before continuing this setup
     * (fractional delay in serving initial route but we need to catch
     * referrer for deep links).
     */
    this.$router.isReady().then(async () => {
      // get logged in user details
      if (getCookie("BEARER_TOKEN")) {
        // set this
        this.$axios.defaults.headers.common["Authorization"] =
          "Bearer " + getCookie("BEARER_TOKEN");
        // call this
        this.getClientAndUserConfig();
      } else {
        this.loggedIn = false;
        //wait for site config so we have the public site flag
        await this.$axios
          .get("/get-site-config")
          .then(
            function (response) {
              this.config = response.data;
              this.redirectSuspendedPublicSite();
              // set this flag
              this.isSuspendedOnProduction = false;
              // set the display ons source
              this.$store.state.displayOnsSource = JSON.parse(
                process.env.VUE_APP_DISPLAY_ONS_SOURCE,
              )[this.config.siteConfig.site_country];
              // check if this is a public site
              if (this.config.siteConfig.is_public_site) {
                this.setUpModules();

                // set the bearer token cookie for 2 hours, add it to the axios auth header
                setCookie("BEARER_TOKEN", this.config.userConfig.token, 2);
                this.$axios.defaults.headers.common["Authorization"] =
                  "Bearer " + getCookie("BEARER_TOKEN");

                //get count of public reports for nav format
                this.setPublicReportCount();
              }
              if (typeof this.config.userProfile !== "undefined") {
                if (this.config.userProfile.is_public_site_user_profile) {
                  setCookie("OI_PUBLIC_SITE", true, 2);
                }
              } else {
                document.cookie =
                  "OI_PUBLIC_SITE=; domain=.localinsight.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
              }
              this.busy = false;

              this.setToolbarTextColour();
            }.bind(this),
          )
          .catch(
            function (error) {
              // handle error
              console.error(error);
              // if it's suspended on production then show the message
              if (error.response.data.errors[0].includes("suspended")) {
                this.isSuspendedOnProduction = true;
              }
              this.busy = false;
            }.bind(this),
          );

        //handle auth redirects and deep links
        this.handleReferrerRouting();
      }
      this.$store.dispatch("servicesDirectory/initFromUrl", this.$route);
    });

    // Set up exit intent functionality
    this.setupExitIntent();
  },
  beforeUnmount() {
    // Clean up exit intent listeners and timers
    this.cleanupExitIntent();
  },
  methods: {
    handleReferrerRouting() {
      // Capture referrer and basic route facts
      this.referrer = this.$route;
      const path = this.$route.path;
      const q = this.$route.query || {};

      // Resolve route access
      const { matched } = this.$router.resolve(this.referrer.path);
      const hasAccess = matched.length > 0;
      const isAuthRoute = securedRoutes.some((r) => {
        const base = r.path.match(/^(\/[^/]+)/)?.[0] || "/";
        return base === this.referrer.path;
      });

      // Convenience flags
      const isPreflight = path === "/preflight";
      const isMap = path === "/map";
      const isLogin = path === "/login";
      const isPublic = !!this.config?.siteConfig?.is_public_site;

      const token = q.token;
      const invitationToken = q.invitationToken;

      // 1) Preflight resolution (decide landing once config is known)
      if (isPreflight) {
        if (isPublic) {
          this.loggedIn = true;
        }
        this.$router.replace({ name: isPublic ? "Home" : "Login" });
        return;
      }

      // 2) Auth flows & auth tokens (login /password reset / invitation)
      if (isLogin || token || invitationToken) {
        if (isLogin) {
          return; // allow login route to proceed
        }

        // password reset or new user invitation - clear bearer token cookie once
        document.cookie =
          "BEARER_TOKEN=; domain=.localinsight.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        this.$router.push({
          path: token ? "/login/forgotten-password" : "/invitation",
          query: { ...q },
        });
        return;
      }

      // 3) Public site map and deep-links to shared Map/report (we allow access to map on public sites without auth)
      if (isMap && isPublic) {
        this.loggedIn = true;
        return;
      }

      // 4) Public site access to non-secured routes
      if (!isAuthRoute && hasAccess && isPublic) {
        this.loggedIn = true;
        return;
      }

      // 5) Non-public secured route without auth -> require login
      if (this.$route.name !== "Login" && isAuthRoute && !this.loggedIn) {
        this.referrer = this.$route;
        this.$router.replace({ name: "Login" });
        return;
      }

      // 6) Fallbacks: public to Home; standard to Login
      this.$router.replace({ name: isPublic ? "Home" : "Login" });
    },
    redirectSuspendedPublicSite() {
      if (
        this.config.siteConfig.is_public_site &&
        this.config.customClientConfig.account_suspended &&
        process.env.VUE_APP_ENVIRONMENT === "prod"
      ) {
        // console.log("redirectSuspendedPublicSite");
        document.cookie =
          "BEARER_TOKEN=; domain=.localinsight.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        window.location.href =
          "https://localinsight.org/?subscription=ended&utm_source=platform&utm_medium=redirect&utm_campaign=subscription-ended";
      }
    },
    checkLegal(config) {
      if (config.userProfile.is_public_site_user_profile) {
        return true;
      } else if (
        config.userProfile.date_user_accepted_terms_of_service &&
        config.userProfile.date_user_accepted_privacy_policy
      ) {
        return true;
      } else {
        this.notSigned = true;
        // deleting this prevents the main app from loading in the dom
        delete this.config.siteConfig.page_title;
        console.info(
          "user has not accepted Accepted Terms Of Service And Privacy Policy",
        );
        return false;
      }
    },
    openReport() {
      this.systemBusy(true);
      if (!this.viewReportDialog) {
        this.viewReportDialog = true;
      }
      this.viewReportButtonLabel = false;
      this.systemBusy(false);
    },
    visitSite(url) {
      var port = location.port ? ":" + location.port : "";
      var redirectURL =
        location.protocol +
        "//" +
        process.env.VUE_APP_ENVIRONMENT_SUB_DOMAIN +
        url +
        port +
        "/#" +
        this.$route.path;
      window.location.replace(redirectURL);
    },
    switchToDifferentClient() {
      if (this.switchClient) {
        this.$axios
          .get("/switch-client/" + this.switchClient.id)
          .then(
            function (response) {
              if (response.data) {
                var port = location.port ? ":" + location.port : "";
                var redirectURL =
                  location.protocol +
                  "//" +
                  process.env.VUE_APP_ENVIRONMENT_SUB_DOMAIN +
                  this.switchClient["url"] +
                  port +
                  "/#" +
                  this.$route.path;
                // some clients will have the same url
                if (redirectURL === window.location.href) {
                  location.reload();
                } else {
                  window.location.replace(redirectURL);
                }
              } else {
                this.emit.emit("systemMessage", {
                  title: "Error!",
                  message: "You do not have access to this client",
                  timeout: 6000,
                  colour: "error",
                });
              }
            }.bind(this),
          )
          .catch(
            function (error) {
              // it would appear there is something wrong...probably an invalid bearer token
              console.error("invalid user details and or token" + error);
              this.emit.emit("systemMessage", {
                message: error.response.data.message,
                colour: "error",
              });
              this.logout();
            }.bind(this),
          );
      }
    },
    router(path) {
      // if a path is http then redirect to that url
      if (path.indexOf("http") > -1) {
        window.open(path, "_blank");
        return;
      }

      // handle public reports redirect
      if (path === "public-reports") {
        if (this.$route.path !== "/map" && this.$route.path !== "/") {
          this.$router.push("/map");
          setTimeout(() => {
            document.getElementById("mapReportsButton").click();
          }, 500);
        } else {
          document.getElementById("mapReportsButton").click();
        }
      } else {
        const target = `/${path}`;
        const currentPath = this.$route.path;

        // if we're not already on the target route (or a child)
        if (currentPath !== target && !currentPath.startsWith(target + "/")) {
          this.$router.push(target);
        }
      }
      this.drawer = false;
    },
    /** fetch logged in user config and site info */
    getClientAndUserConfig(referrer) {
      this.$axios
        .get("/client-user-site-config")
        .then(
          function (response) {
            this.config = response.data;
            this.redirectSuspendedPublicSite();
            if (!this.checkLegal(response.data)) {
              return;
            }

            this.$store.state.displayOnsSource = JSON.parse(
              process.env.VUE_APP_DISPLAY_ONS_SOURCE,
            )[this.config.siteConfig.site_country];
            // catch this
            if (this.config.siteConfig.is_public_site) {
              // need to catch if this
              if (getURLParam("token")) {
                this.systemBusy(false);
                if (this.$route.name !== "Login") {
                  if (referrer) {
                    this.$router.push(referrer);
                  } else {
                    this.router("map");
                  }
                }
                return;
              }
            }
            // set permission level
            this.setPermissionLevel();

            //now we have config and permissions set up the modules and routes
            this.setUpModules();

            // set the toolbar text colour depending on the background brightness
            this.setToolbarTextColour();
            // make sure we are using the correct url..if not then they will be redirected to the one assciated to their user account
            if (
              process.env.VUE_APP_ENVIRONMENT_SUB_DOMAIN +
                this.config.siteConfig.url !==
              window.location.hostname
            ) {
              var port = location.port ? ":" + location.port : "";
              const path = referrer ? referrer.fullPath : "/map";

              var redirectURL =
                location.protocol +
                "//" +
                process.env.VUE_APP_ENVIRONMENT_SUB_DOMAIN +
                this.config.siteConfig.url +
                port +
                "/#" +
                path;
              window.location.replace(redirectURL);
            } else {
              // re(set) the bearer token cookie for another 2 hours
              setCookie("BEARER_TOKEN", getCookie("BEARER_TOKEN"), 2);
              // set these
              this.systemBusy(false);
              this.loggedIn = true;
              // redirect to the members area
              if (["Login", "Invitation"].includes(this.$route.name)) {
                //if referrer route obect passed in from login page then redirect to that
                if (referrer) {
                  this.$router.push(referrer);
                } else {
                  //catch all - if no referrer passed go to map page
                  this.router("map");
                }
              }
            }
          }.bind(this),
        )
        .catch(
          function (error) {
            // it would appear there is something wrong...probably an invalid bearer token
            console.error("invalid user details and or token" + error);
            this.emit.emit("systemMessage", {
              message: error.response.data.message,
              colour: "error",
            });
            this.logout();
          }.bind(this),
        );
    },
    // call this to log users out
    logout() {
      if (this.sessionExpired) {
        // set this
        delete this.config.siteConfig.page_title;
        // clear the bearer cookie
        document.cookie =
          "BEARER_TOKEN=; domain=.localinsight.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        //end intercom session
        this.emit.emit("intercom:shutdown");
        return;
      }
      this.$store.commit("resetConfig");
      // set this
      this.systemBusy(true);
      // reset this
      this.loggedIn = false;
      // call this
      this.$axios
        .post("/logout")
        .catch(
          function (error) {
            // it would appear there is something wrong...probably an invalid bearer token
            console.error("(logout) invalid user details and or token" + error);
          }.bind(this),
        )
        .then(
          function () {
            // clear the bearer cookie
            document.cookie =
              "BEARER_TOKEN=; domain=.localinsight.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            //end intercom session
            this.emit.emit("intercom:shutdown");
            //reload app to login page
            this.$router.go();
          }.bind(this),
        );
    },
    getNavGroupModules(groupedModules) {
      // Convert object to array of values, then flatMap
      return Object.values(groupedModules).flatMap((group) => {
        return group.groupModules || [];
      });
    },
    setUpModules() {
      const publicModules = this.config.userProfile.is_public_site_user_profile
        ? this.config.userConfig.modules
        : this.getNavGroupModules(this.config.userConfig.modules);
      const storedRoutes = this.$router.getRoutes(); // what we currently have stored
      Object.values(publicModules).forEach((module) => {
        const target = `/${module.route}`;
        // in the list of secured routes, find the one that matches the user's allowed module
        const matchingSecuredRoutes = securedRoutes.filter((route) => {
          // Remove params for comparison
          const staticPath = route.path.replace(/:[^/]+\\??/g, "");
          // Ensure staticPath starts with target as a directory
          return staticPath.startsWith(target);
        });

        // find many matching route definitions if they exist and add them to the router
        matchingSecuredRoutes.forEach((securedModule) => {
          if (
            securedModule &&
            !storedRoutes.some((route) => route.path === securedModule.path) // check if the route is already stored
          ) {
            this.$router.addRoute(securedModule);
          }
        });

        // make chart-sandbox and report-sandbox available in non-prod environments
        if (["dev", "stg", "uat"].includes(process.env.VUE_APP_ENVIRONMENT)) {
          ["/chart-sandbox", "/report-sandbox"].forEach((sandboxRoute) => {
            if (
              !storedRoutes.some((route) => route.path === sandboxRoute) // check if the route is already stored
            ) {
              const matchingSandboxRoute = securedRoutes.find(
                (route) => route.path === sandboxRoute,
              );
              if (matchingSandboxRoute) {
                this.$router.addRoute(matchingSandboxRoute);
              }
            }
          });
        }
      });
      this.$router.replace(this.$route.fullPath);
    },
    /*
        Module group values — used to restrict or show certain functionality in the UI.
        The value is true for higher permission levels, so there's no need to list all higher levels in an "if" condition.
    */
    setPermissionLevel() {
      switch (this.config.userConfig.permission_level) {
        // ocsi big boss
        case 1:
          this.isOcsiMember = true;
          this.isGroupAdmin = true;
          this.isPowerUser = true;
          this.isViewReports = true;
          this.isPublicUser = true;
          break;
        // group admin
        case 2:
          this.isGroupAdmin = true;
          this.isPowerUser = true;
          this.isViewReports = true;
          break;
        // power user
        case 3:
          this.isPowerUser = true;
          this.isViewReports = true;
          break;
        // view reports
        case 4:
          this.isViewReports = true;
          break;
        // public user
        case 5:
          this.isPublicUser = true;
          break;
      }
    },
    // for api calls..this shows the progress bar and adds a transparent layer over the screen to stop any button mashing
    systemBusy(state) {
      // if it's an object, then read it
      if (typeof state === "object") {
        this.busy = state.busy;
        this.showAntiMasher = state?.showAntiMasher;
        this.showProgressLoader = state.showProgressLoader;
      } else {
        this.busy = state;
        this.showAntiMasher = state;
        this.showProgressLoader = true;
      }
    },
    // shows messages on the screen
    displaySnackbar(info) {
      info.message =
        "message" in info && info["message"] !== null ? info.message : null;
      info.title =
        "title" in info && info["title"] !== null ? info.title : null;
      if (info.message !== null && info.title === null) {
        info.title = info.message;
        info.message = null;
      }

      info.timeout =
        "timeout" in info && info["timeout"] !== null ? info.timeout : 4000;
      info.colour =
        "colour" in info && info["colour"] !== null ? info.colour : null;
      info.location =
        "location" in info && info["location"] !== null ? info.location : "top";
      info.rounded =
        "rounded" in info && info["rounded"] !== null ? info.rounded : "none";
      info.icon = "icon" in info ? info.icon : "mdi-alert-circle-outline";
      info.width = "width" in info ? info.width : "640px";
      info.showClose = "showClose" in info ? info.showClose : true;
      info.textColour = "textColour" in info ? info.textColour : "text-white";
      info.contactSupportBtn =
        "contactSupportBtn" in info ? info.contactSupportBtn : false;
      info.button =
        "button" in info &&
        info["button"] !== null &&
        info.button?.text &&
        info.button?.callback
          ? info.button
          : null;

      this.snackbarVisible = false;
      this.snackbar.message = info.message;
      this.snackbar.title = info.title;
      this.snackbar.timeout = info.timeout;
      this.snackbar.colour = info.colour;
      this.snackbar.icon = info.icon;
      this.snackbar.location = info.location;
      this.snackbar.rounded = info.rounded;
      this.snackbar.width = info.width;
      this.snackbar.showClose = info.showClose;
      this.snackbarVisible = true;
      this.snackbar.id = {
        green: "successSnackbar",
        success: "successSnackbar",
        error: "errorSnackbar",
        red: "errorSnackbar",
        warning: "warningSnackbar",
      }[info.colour];
      this.snackbar.textColour = info.textColour;
      this.snackbar.contactSupportBtn = info.contactSupportBtn;
      this.snackbar.button = info.button;
    },
    closeSnackbar() {
      this.snackbarVisible = false;
    },
    setToolbarTextColour() {
      let backgroundColor = this.$store.state.config.siteConfig.toolbar_colour;

      // Determine the text color based on the brightness
      this.titleTextColor = isBrightColour(backgroundColor) ? "black" : "white";

      // Create a new style element
      let style = document.createElement("style");
      style.type = "text/css";

      // Add a CSS rule to the style element
      style.innerHTML = `
        .dynamicTextColour,
        .text-report-loading,
        .v-overlay__content > .v-card-title,
        .v-dialog > .v-overlay__content > .v-card > .v-toolbar > .v-toolbar__content,
        .v-overlay__content > .v-card > .v-card-title {
          color: ${this.titleTextColor};
        }
      `;

      // Append the style element to the head of the document
      document.getElementsByTagName("head")[0].appendChild(style);
    },
    logInAgain() {
      this.sessionExpired = false;
      this.logout();
    },
    startCountdown() {
      this.countdownTime = 300; // Reset to 5 minutes
      this.updateFormattedTime();

      this.countdownTimer = setInterval(() => {
        this.countdownTime--;
        this.updateFormattedTime();

        if (this.countdownTime <= 0) {
          this.stopCountdown();
          this.sessionExpired = true;
          this.logout();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    updateFormattedTime() {
      const minutes = Math.floor(this.countdownTime / 60);
      const seconds = this.countdownTime % 60;
      const minuteLabel = minutes === 1 ? "minute" : "minutes";
      this.formattedTime = `${minutes.toString().padStart(2, "0")} ${minuteLabel} ${seconds.toString().padStart(2, "0")} seconds`;
    },
    sessionExpiring() {
      this.sessionExpiryDialog = true;
      this.startCountdown();
    },
    continueSession() {
      this.sessionExpiryDialog = false;
      this.stopCountdown();
      // Trigger the interceptor to reset the session timer
      const mockResponse = { data: {} };
      this.$axios.interceptors.response.handlers[0].fulfilled(mockResponse);
    },
    showNewChip(moduleSlug) {
      const newModulesSlug = ["datastore", "services"];
      return newModulesSlug.includes(moduleSlug);
    },
    setupExitIntent() {
      // Set up 40-second timer (starting after 10 seconds grace period)
      this.exitIntentTimer = setTimeout(() => {
        if (!this.exitIntentTriggered) {
          this.exitIntentDialog = true;
          this.exitIntentTriggered = true;
        }
      }, 40000); // 40 seconds

      // Set up mouse move listener for exit intent after 10 seconds grace period
      setTimeout(() => {
        document.addEventListener("mousemove", this.handleMouseMove);
      }, 10000); // 10 seconds grace period
    },
    handleMouseMove(event) {
      // Check if mouse is in top 20px of the page
      if (event.clientY <= 20 && !this.exitIntentTriggered) {
        this.exitIntentDialog = true;
        this.exitIntentTriggered = true;
        // Clear the timer since we've already triggered
        if (this.exitIntentTimer) {
          clearTimeout(this.exitIntentTimer);
        }
      }
    },
    closeExitIntentDialog() {
      this.exitIntentDialog = false;
    },
    handleExitIntentOk() {
      this.exitIntentDialog = false;
      this.$router.push("/purchase/imd-report/included-themes");
    },
    cleanupExitIntent() {
      if (this.exitIntentTimer) {
        clearTimeout(this.exitIntentTimer);
      }
      document.removeEventListener("mousemove", this.handleMouseMove);
    },
    setPublicReportCount() {
      this.$axios
        .get("/public-report-count")
        .then(
          function (response) {
            this.publicReportCount = response.data;
          }.bind(this),
        )
        .catch(
          function (error) {
            console.error("error getting public report count" + error);
          }.bind(this),
        );
    },
    showModuleInNav(item) {
      const filteredModules = ["public-reports"];

      // if nav module entry doesn't require any kind of filtering then show it
      if (!filteredModules.includes(item.slug)) {
        return true;
      }

      // public  site reports link should be hidden if no reports exist
      if (item.slug === "public-reports" && this.publicReportCount == 0) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="css">
body {
  font-family: "Inter", sans-serif !important;
}

.text-body-1,
.text-body-2,
.text-overline,
.text-caption,
.v-card-title,
.v-toolbar-title,
.v-toolbar__content,
.content,
.v-dialog,
.v-card-text,
.text-body-1,
.text-subtitle-1,
.v-application,
.v-overlay-container,
.text-h6,
.text,
.pb-2,
.text-h5,
.text-subtitle-1,
.text-subtitle-2 {
  font-family: "Inter", sans-serif !important;
}

.h1 {
  font-size: 1.25rem;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  letter-spacing: 0.0125em;
  line-height: 2rem;
}

.weight-600 {
  font-weight: 600 !important;
}

.app-report {
  border: 1px solid red !important;
}

.loadingLI {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* allow whitespace in snackbar messages */
#snackBarMessage {
  white-space: pre-wrap;
}

/* slow the spinners*/
.v-progress-circular--indeterminate .v-progress-circular__overlay {
  animation:
    progress-circular-dash 2.6s ease-in-out infinite,
    progress-circular-rotate 2.6s linear infinite !important;
}

.otherLinks {
  color: #0645ad;
  text-decoration: underline;
  font-size: 13px !important;
}

.app {
  background-color: #ebf2f6 !important;
}

#inspire {
  animation: fadeInAnimation ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  overflow: hidden;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.antiMasher {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10000000000;
}

.progressBar {
  position: fixed;
  width: 100vw;
  z-index: 10000;
}

#app {
  font-family: "Inter", serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

h1 {
  color: #51627c;
  font-size: 20p;
  font-family: Inter, sans-serif !important;
}

h2 {
  color: #51627c;
  font-size: 16p;
  font-family: Inter, sans-serif !important;
}

h3 {
  color: #51627c;
  font-size: 14p;
  font-family: Inter, sans-serif !important;
}

p {
  color: black;
  font-size: 11p;
  font-family: Inter, sans-serif !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.min-accessible-size {
  font-size: 12pt;
}

/*this is for the get all button loader animation*/
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.moduleList .v-list-item--density-default.v-list-item--one-line {
  min-height: 45px;
}

.extraModuleList .v-list-item--density-default.v-list-item--one-line {
  min-height: 45px;
}

/* make the tip tap fullscreen mode appear under the LI header */
.vuetify-pro-tiptap-editor--fullscreen {
  padding: 50px !important;
}

.progressText {
  width: 100%;
  text-align: center;
  font-size: 14px;
  height: 300px;
}

.progress {
  margin-top: 150px;
  width: 100%;
}

/* view of the disabled elevated button */
.v-btn--disabled.v-btn--variant-elevated {
  background-color: #acacac !important;
}

.v-btn--disabled.v-btn--variant-elevated .v-btn__append,
.v-btn--disabled.v-btn--variant-elevated .v-btn__prepend,
.v-btn--disabled.v-btn--variant-elevated .v-btn__content {
  color: #000000 !important;
}

.v-btn--disabled.v-btn--variant-elevated .v-btn__overlay,
.v-btn--disabled.v-btn--variant-flat .v-btn__overlay {
  opacity: 0.105384615 !important;
}

/* green elevated button colour */
.v-btn--elevated.bg-success {
  background-color: #265928 !important;
}

/* overwrite the info alert styles */
.v-btn--elevated.bg-info {
  background-color: #0e5b99 !important;
}

.v-alert.bg-info,
.v-alert.text-info {
  background-color: #bfe0f8 !important;
  color: #093f6b !important;
}

/* Create a pseudo element for the gradient background before the text
   and stretch it to cover the whole help centre button. This is a
   workaround for lack of support for transitions between linear-gradients */
#help-centre-item {
  position: relative;
  overflow: hidden;
}

#help-centre-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    linear-gradient(
      90deg,
      rgba(141, 200, 241, 1) 0%,
      rgba(194, 149, 252, 1) 100%
    ),
    linear-gradient(white, white);
  opacity: 0.5;
  transition: opacity 0.3s ease;
  z-index: -1;
}

#help-centre-item:hover::before {
  background:
    linear-gradient(
      90deg,
      rgba(141, 200, 241, 1) 0%,
      rgba(194, 149, 252, 1) 100%
    ),
    linear-gradient(white, white);
  opacity: 1;
}

/* make the expansion panel titles smaller */
.staticExpansionTitlePanel {
  max-height: 47px !important;
  min-height: 10px !important;
}

/* to avoid pure black */
.text {
  color: #4d4d4d;
}

/* allow pill snackbars to be smaller */
#ocsi-snackbar .v-snackbar__wrapper {
  min-width: 50px !important;
}

/* add more contrast to the background to see white content better */
.greyed-bg {
  background-color: #f9f9f9;
}

/* redure the rounded corners for the year picker buttons */
.v-date-picker-years__content .v-btn--rounded {
  border-radius: 5px;
}

.grayedBackground {
  background-color: #f9f9f9 !important;
}

.cardTitle {
  color: #4d4d4d !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

.grayedText * {
  color: #4d4d4d !important;
}

.v-alert.bg-warning {
  color: #8b4c04 !important;
  background-color: #ffeaa5 !important;
}

.v-alert.bg-warning .mdi-information {
  font-size: 24px !important;
  width: 24px !important;
  height: 24px !important;
}

/* remove box shadow from chips */
.chips .v-chip--variant-elevated {
  box-shadow: none;
}

.prompt {
  border: solid 1px #c2c2c2;
  border-radius: 8px;
  color: #0e5b99;
  background: white;
}

.promptCard :hover {
  cursor: pointer;
  background-color: #bfe0f8;
}

/* chip style for color="warning"  */
.v-chip.bg-warning {
  background-color: #fdd9af !important;
  font-weight: 400;
}

.v-chip.bg-warning .v-chip__content {
  color: #4f2a00 !important;
}

.bg-inverted-warning {
  background-color: rgb(var(--v-inverted-warning)) !important;
}

.on-inverted-warning {
  color: rgb(var(--v-on-inverted-warning)) !important;
}

.on-inverted-success {
  color: rgb(var(--v-on-inverted-success)) !important;
}
.copyright {
  color: #fff;
  background-color: #333333;
  font-weight: 300;
  font-size: 12px;
  padding: 5px;
  font-family: "Kanit", sans-serif;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
/* Remove focus outline for mouse users only */
button:focus,
.v-btn:focus {
  outline: none !important;
}
button:focus-visible,
.v-btn:focus-visible {
  /* outline: 2px solid #1976d2 !important; */
  outline: 2px solid #1976d2 !important;
}
.v-selection-control--focused .v-selection-control__input::before {
  background-color: black !important;
}

.bg-mint {
  background-color: #3edbcf !important;
}

/* Header responsive fixes to avoid overlap between client name and IMD button */

/* Ensure topBar behaves as a flex container; media queries will allow wrapping */
.topBar {
  width: 100%;
}

/* Ensure toolbar content doesn't wrap and stays vertically centered */
#appBar .v-toolbar__content,
#appBar .v-app-bar__content,
.topBar .v-toolbar__content,
.topBar .v-app-bar__content {
  display: flex;
  align-items: center !important;
  align-content: center !important;
  flex-wrap: nowrap !important;
}

/* Ensure inner rows don’t wrap and stay vertically centered */
#appBar .v-toolbar__content > .v-row,
#appBar .v-app-bar__content > .v-row {
  align-items: center !important;
  flex-wrap: nowrap !important;
}

/* Client name container: allow truncation and ensure it can shrink inside flex */
.clientName {
  border-left: 1px solid #fff;
  font-weight: 400 !important;
  min-width: 0; /* allow flex children to shrink correctly */
  flex: 1 1 auto; /* let title take remaining space */
}

/* ensure the inner text is truncated and stays on one line */
.clientNameText {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* right side container (reports and IMD button) */
.headerRight {
  flex: 0 0 auto !important; /* do not grow or shrink; keep intrinsic width */
  min-width: 160px; /* reserve space so title ellipsizes before colliding */
}

/* Reserve space for the reports area so it can render properly */
.headerRight .reportsCol {
  flex: 0 0 clamp(260px, 30vw, 460px) !important;
  min-width: 240px;
}

.headerRight .reportsCol .v-progress-linear {
  width: 100%;
  min-width: 0;
}

/* IMD button: keep full size and prevent text overflow */
.imdBtn {
  flex: 0 0 auto !important; /* do not shrink; keep full size */
  min-width: max-content; /* size to label text */
  margin-left: 12px !important; /* add a bit more gap so title ellipsis remains visible */
  box-sizing: border-box;
  align-self: center; /* keep vertically centered in the app bar */
  height: 35px !important; /* lock to app-bar height to avoid vertical push */
  max-height: 40px !important;
  padding: 0px 16px;
}
.imdBtn .v-btn__content {
  white-space: nowrap;
}

/* End header responsive fixes */

/* Intercom banner absolute positioning - targets only the banner iframe */
iframe[name="intercom-banner-frame"],
iframe[title*="banner"],
.intercom-banner-frame {
  position: fixed !important;
  top: 48px !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  z-index: 1000 !important;
  transition: opacity 0.3s ease !important;
}

/* Hide banner when navigation drawer is open */
.v-navigation-drawer--active iframe[name="intercom-banner-frame"],
.v-navigation-drawer--active iframe[title*="banner"],
.v-navigation-drawer--active .intercom-banner-frame,
body:has(.v-navigation-drawer--active) iframe[name="intercom-banner-frame"],
body:has(.v-navigation-drawer--active) iframe[title*="banner"],
body:has(.v-navigation-drawer--active) .intercom-banner-frame {
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Ensure page content accounts for fixed banner */
body {
  margin-top: 0 !important;
}

/* Prevent banner from affecting document flow */
#intercom-container {
  height: 0 !important;
  overflow: visible !important;
}
</style>
